/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Table from "../../EntryFile/datatable";
import Tabletop from "../../EntryFile/tabletop"
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ClosesIcon,
  Excel,
  Filter,
  Pdf,
  Calendar,
  Printer,
  search_whites,
  Search,
  MacbookIcon,
  OrangeImage,
  PineappleImage,
  StawberryImage,
  AvocatImage,
  Product1,
  Product7,
  Product8,
  Product9,
} from "../../EntryFile/imagePath";
import Select2 from "react-select2-wrapper";
import "react-select2-wrapper/css/select2.css";

const Purchaseorder = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());

  const options = [
    { id: 1, text: "Choose Supplier", text: "Choose Product" },
    { id: 2, text: "Supplier", text: "Supplier" },
  ];
  const [inputfilter, setInputfilter] = useState(false);

  const togglefilter = (value) => {
    setInputfilter(value);
  };
  const [data] = useState([
    {
      id:1,
      Name: "Macbook pro",
      amount: 38698,
      Purchased: 1248,
      Instock: 1356,
      image: Product1,
    },
    {
      id:2,
      Name: "Orange",
      amount: 36080,
      Purchased: 110,
      Instock: 131,
      image: OrangeImage,
    },
    {
      id:3,
      Name: "Pineapple",
      amount: 21000,
      Purchased: 106,
      Instock: 131,
      image: PineappleImage,
    },
    {
      id:4,
      Name: "Strawberry",
      amount: 11000,
      Purchased: 105,
      Instock: 100,
      image: StawberryImage,
    },
    {
      id:5,
      Name: "Sunglasses",
      amount: 10600,
      Purchased: 105,
      Instock: 100,
      image: AvocatImage,
    },
    {
      id:6,
      Name: "Unpaired gray",
      amount: 9984,
      Purchased: 50,
      Instock: 50,
      image: MacbookIcon,
    },
    {
      id:7,
      Name: "Avocat",
      amount: 4500,
      Purchased: 41,
      Instock: 29,
      image: Product7,
    },
    {
      id:8,
      Name: "Banana",
      amount: 900,
      Purchased: 28,
      Instock: 24,
      image: Product8,
    },
    {
      id:9,
      Name: "Earphones",
      amount: 500,
      Purchased: 20,
      Instock: 11,
      image: Product9,
    },
    {
      id:10,
      Name: "Banana",
      amount: 900,
      Purchased: 28,
      Instock: 24,
      image: Product8,
    },
    {
      id:11,
      Name: "Earphones",
      amount: 500,
      Purchased: 20,
      Instock: 11,
      image: Product9,
    },
  ]);

  const columns = [
    {
      title: "Product Name",
      dataIndex: "Name",
      render: (text, record) => (
        <div className="productimgname">
          <Link to="#" className="product-img">
            <img src={record.image} alt="product" />
          </Link>
          <Link to="#">{text}</Link>
        </div>
      ),
      sorter: (a, b) => a.Name.length - b.Name.length,
    },
    {
      title: "Purchased amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Purchased QTY",
      dataIndex: "Purchased",
      sorter: (a, b) => a.Purchased.length - b.Purchased.length,
    },
    {
      title: "Instock QTY",
      dataIndex: "Instock",
      sorter: (a, b) => a.Instock.length - b.Instock.length,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Purchase order report</h4>
            <h6>Manage your Purchase order report</h6>
          </div>
        </div>
        {/* /product list */}
        <div className="card">
          <div className="card-body">
            <Tabletop inputfilter={inputfilter} togglefilter={togglefilter} />
            {/* /Filter */}
            <div
              className={`card mb-0 ${inputfilter ? "toggleCls" : ""}`}
              id="filter_inputs"
              style={{ display: inputfilter ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="form-group">
                      <div className="input-groupicon">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                        />
                        <div className="addonset">
                          <img src={Calendar} alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="form-group">
                      <div className="input-groupicon">
                        <DatePicker
                          selected={startDate1}
                          onChange={(date) => setStartDate1(date)}
                        />
                        <div className="addonset">
                          <img src={Calendar} alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="form-group">
                      <Select2
                        className="select"
                        data={options}
                        options={{
                          placeholder: "Choose Suppliers",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div className="form-group">
                      <a className="btn btn-filters ms-auto">
                        <img src={search_whites} alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table
              columns={columns}
              dataSource={data}
              rowKey={(record) => record.id}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
    </div>
  );
};

export default Purchaseorder;
